if (!customElements.get('regularity-banner')) {
  customElements.define(
    'regularity-banner',
    class RegularityBanner extends HTMLElement {
      connectedCallback() {
        this.btn = this.querySelector('.lp-hero__button');
        if (!this.btn) return;
        this._onClick = this.handleClick.bind(this);
        this.btn.addEventListener('click', this._onClick);
      }

      disconnectedCallback() {
        if (this.btn && this._onClick) {
          this.btn.removeEventListener('click', this._onClick);
        }
        this.btn = null;
        this._onClick = null;
      }

      handleClick(event) {
        const href = this.btn.getAttribute('href');

        if (href && href.startsWith('#') && href.length > 1) {
          const target = document.querySelector(href);

          if (target) {
            event.preventDefault();

            const prefersReducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches;
            const behavior = prefersReducedMotion ? 'auto' : 'smooth';

            const bodyPaddingTop = Number.parseFloat(window.getComputedStyle(document.body).paddingTop) || 0;
            const stickyHeader = document.querySelector('.header-sticky');
            const stickyHeaderHeight = stickyHeader?.getBoundingClientRect?.().height || 0;
            const offset = Math.max(bodyPaddingTop, stickyHeaderHeight);

            const targetTop = target.getBoundingClientRect().top + window.scrollY;
            const top = Math.max(0, targetTop - offset);

            window.scrollTo({ top, behavior });
          }
        }
      }
    }
  );
}
